<template>
  <div
    id="Aie-Pay"
    class="h100"
  >
    <router-view />
  </div>
</template>

<script>
import saasApi from './utils/saasApi';
import getApiConfig from './utils/configHook';

export default {
  name: 'Aie-Pay',
  methods: {
    // 获取主体id
    //  akt.com：评测学 pcx.com：艾速度 20200：袁颂
    async apiGetMainId() {
      let mainUrl = '';

      // 支付主体的url，原则上从hostname中获取
      if (process.env.NODE_ENV !== 'production') {
        const payConfig = await getApiConfig();
        // 如果启用了SaaS模式，则使用DO_MAIN_NAME，因为domainName充当了当前域名
        if (payConfig.IS_SAAS_MODE) {
          mainUrl = payConfig.DO_MAIN_NAME;
        } else {
          mainUrl = payConfig.PAY_MAIN_URL;
        }
      } else {
        // SaaS配置中，带有payMainId，此处重新获取（pingcexue与aisudu没有SaaS配置），都是依据hostname
        var index = location.hostname.indexOf('.');
        mainUrl = location.hostname.substring(index + 1);
      }

      this.$store.commit('setMainUrl', mainUrl);
      console.log('Pay Main Url:', this.$store.state.mainUrl);

      // 根据当前url，获取支付主体id
      const res = await saasApi.get(`/open/getPayMainId/${mainUrl}`);
      if (res.data && res.data.code === '200') {
        // 保存mainId
        this.$store.commit('setMainId', res.data.data);
        console.log('Pay Main Id:', this.$store.state.mainId);
      } else {
        console.log('Pay Main Id Error:', res);
        this.$message({
          type: 'error',
          message: '未找到支付主体！',
        });
      }
    },
  },

  async created() {
    await this.apiGetMainId();
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue